import React from 'react';
 
function FixedPanel(props) {
    const {children, className} = props;
   
    return <div className={["fixedPanel", className].join(" ")}>{children}</div>
}
 
export default FixedPanel;
